import toast from 'react-hot-toast';
import {
  Box,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { BACKEND_URL } from '../../../utils/apiConfig';
import { authFetch } from '../../../utils/authHelpers';
import { T, Icon, stitchGradientBtn } from '../parts/stitch';
import DeliverableCard from '../parts/DeliverableCard';
import { useProjectData } from '../ProjectDataContext';

function DeliverablesPanel({ onOpenDetail, onGenerateTasks, gemarkeerdId = null }) {
  const navigate = useNavigate();
  const {
    id,
    loadData,
    project,
    deliverables,
    tasksPerDeliverable,
  } = useProjectData();

  return (
    <>
        {deliverables.length === 0 ? (
          <Box sx={{ textAlign: 'center', py: 6 }}>
            <Icon name="movie" size={48} sx={{ color: T.outlineVariant, display: 'block', mx: 'auto', mb: 1 }} />
            <Typography sx={{ fontFamily: T.fontBody, color: T.outline, mb: 2 }}>Geen deliverables gevonden</Typography>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
              <Box
                component="span"
                onClick={async () => {
                  try {
                    const airtableId = project?.airtable_id || project?.id;
                    const res = await authFetch(`${BACKEND_URL}/Api/projects/${airtableId}/auto-deliverables`, {
                      method: 'POST', headers: { 'Content-Type': 'application/json' },
                    });
                    const data = await res.json();
                    if (!res.ok) throw new Error(data.error);
                    if (data.created > 0) {
                      toast.success(`${data.created} deliverable${data.created > 1 ? 's' : ''} aangemaakt${data.skipped ? ` (${data.skipped} overgeslagen)` : ''}`);
                      loadData();
                    } else {
                      toast(data.message || 'Geen nieuwe deliverables gevonden');
                    }
                  } catch (err) { toast.error(err.message || 'Auto-deliverables mislukt'); }
                }}
                sx={stitchGradientBtn}
              >
                Auto-deliverable
              </Box>
              <Box
                component="span"
                onClick={() => navigate(`/deliverables/new?project=${id}`)}
                sx={{ ...stitchGradientBtn, background: `linear-gradient(135deg, ${T.emerald} 0%, #059669 100%)` }}
              >
                <Icon name="add" size={18} />
                Nieuwe deliverable
              </Box>
            </Box>
          </Box>
        ) : (
          <>
          {/* Header with New Deliverable Button */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
            <Box
              component="span"
              onClick={() => navigate(`/deliverables/new?project=${id}`)}
              sx={stitchGradientBtn}
            >
              <Icon name="add" size={18} />
              Nieuwe Deliverable
            </Box>
          </Box>
          <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' } }}>
            {deliverables.map((item) => (
              <DeliverableCard
                key={item.id}
                item={item}
                taskCount={tasksPerDeliverable[item.id] || 0}
                gemarkeerd={!!gemarkeerdId && item.id === gemarkeerdId}
                onClick={() => onOpenDetail(item)}
                onGenerateTasks={onGenerateTasks}
              />
            ))}
          </Box>
          </>
        )}
    </>
  );
}

export default DeliverablesPanel;
